import { useQuery } from "@tanstack/react-query"
import { getCoeficienteAmortizacion } from "./CoeficienteAmortizacion.service"

export function useGetCoeficienteAmortizacion() {
  const {
    data: coeficientesAmortizacion,
    isLoading: coeficientesAmortizacionIsLoading,
    error: coeficientesAmortizacionError,
    refetch: coeficientesAmortizacionRefetch,
  } = useQuery({
    queryKey: ["CoeficienteAmortizacion"],
    queryFn: () => getCoeficienteAmortizacion(),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 2,
    retry: false,
  })

  return {
    coeficientesAmortizacion,
    coeficientesAmortizacionIsLoading,
    coeficientesAmortizacionError,
    coeficientesAmortizacionRefetch,
  }
}
